import { render, staticRenderFns } from "./SkeletonSearchbarOCDetailComponentGlobal.vue?vue&type=template&id=7f2d8625&scoped=true&"
import script from "./SkeletonSearchbarOCDetailComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./SkeletonSearchbarOCDetailComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonSearchbarOCDetailComponentGlobal.vue?vue&type=style&index=0&id=7f2d8625&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2d8625",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSkeletonLoader,VSpacer})
